import { defaultConfigProvider } from '../_util/constant';
export default {
  inject: {
    configProvider: {
      default: defaultConfigProvider
    }
  }
};